import React from "react";
import "./navigation.css";
export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div style ={{display:"inline-block"}} className="container-fluid">
        <div  className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse" 
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll navbar-left" href="#page-top">
            Lucid Capital Funding
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul style ={{display:"inline-block"}} className="nav navbar-nav navbar-right">
            <li >
              <a href="#features" className="">
                Funding Options
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                Apply Now
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
